import ServiceComp from "./ServiceComp";
export default ServiceComp;
